export default __webpack_public_path__ + "static/media/thesun.53426aeb.png";